
import { useQuery } from '@tanstack/react-query';
import MentorCalendar from '../components/MentorCalender';
import MentorHeader from '../components/MentorHeader';
import MentorSideBar from '../components/MentorSiderBar';
import React, { useState, useEffect } from 'react'
import { getMentorDashboard, requestPayout } from '../utils/api';
import { Eye } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

const MentorDashboard = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [loader, setLoader] = useState(false)
  const [error, setError] = useState("");

  const [data, setData] = useState({
    title: "", startTime: null,
    endTime: null, date: null, mentorId: null, isPaid: false, amount: null
  })
  const navigate = useNavigate()
  const toggleSidebar = () => setSidebarOpen((prev) => !prev);
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (mobile) setSidebarOpen(false);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const { data: dashboard, isLoading, refetch } = useQuery({
    queryKey: ['dashboard'],
    queryFn: getMentorDashboard
  })

  const availablePayout = Number(
    dashboard?.data?.summary?.netPayout || 0
  );

  const payoutRequest = async () => {
    if (!data.amount) return;
    setLoader(true)
    try {

      const res = await requestPayout(data);
      toast.success(res.message || "Payout request submitted successfully")

    } catch (error) {
      toast.error(error.message)
      console.log(error)
    } finally {
      setLoader(false)
      setShowModal(false);
      refetch()
      setData({
        ...data, amount: null
      })

    }


  };




  useEffect(() => {
    console.log(dashboard)
  }, [dashboard])

  return (
    <>
      <div className="flex min-h-[100dvh] bg-gray-50 overflow-hidden">
        <MentorSideBar
          isOpen={sidebarOpen}
          toggleSidebar={toggleSidebar}
          isMobile={isMobile}

        />

        <div
          className={`flex flex-col flex-1 transition-all duration-300 overflow-hidden ${isMobile ? "ml-0" : sidebarOpen ? "ml-16 md:ml-20 lg:ml-20" : "ml-0"}`}
        >
          <MentorHeader toggleSidebar={toggleSidebar} isMobile={isMobile} />
          {isLoading ? <MentorEarningsSkeleton /> : <main className="p-6 space-y-10 bg-gray-50 min-h-screen">

            {/* PAGE TITLE */}
            <div className="flex items-center justify-between">
              {/* LEFT CONTENT */}
              <div className="flex flex-col gap-1">
                <h1 className="text-3xl font-bold text-gray-900 tracking-tight">
                  Earnings & Payouts
                </h1>
                <p className="text-sm text-gray-500">
                  Track your earnings, commissions, and payouts from mentoring sessions
                </p>
              </div>

              {/* RIGHT BUTTON */}
              <button
                onClick={() => setShowModal(true)}
                className=" px-5 py-2.5 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition disabled:bg-gray-300 disabled:cursor-not-allowed">
                Request Payout ₹
              </button>
            </div>


            {/* SUMMARY CARDS */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {[
                {
                  label: "Total Earnings",
                  value: '₹' + dashboard?.data?.summary?.totalEarnings?.toLocaleString("en-IN"),
                  color: "from-indigo-500/10 to-indigo-500/5",
                },
                {
                  label: "Platform Commission",
                  value: '₹' + dashboard?.data?.summary?.totalCommission?.toLocaleString("en-IN"),
                  color: "from-red-500/10 to-red-500/5",
                },
                {
                  label: "Net Payout",
                  value: '₹' + dashboard?.data?.summary?.netPayout?.toLocaleString("en-IN"),
                  color: "from-emerald-500/10 to-emerald-500/5",
                },
                {
                  label: "Total Sessions",
                  value: dashboard?.data?.summary?.totalSessions?.toLocaleString("en-IN"),
                  color: "from-amber-500/10 to-amber-500/5",
                },
              ].map((item, index) => (
                <div
                  key={index}
                  className={`relative overflow-hidden rounded-2xl border border-gray-200 bg-white p-5 shadow-sm`}
                >
                  <div
                    className={`absolute inset-0 bg-gradient-to-br ${item.color}`}
                  />

                  <div className="relative">
                    <p className="text-sm text-gray-500">{item.label}</p>
                    <h3 className="mt-2 text-2xl font-bold text-gray-900">
                      {typeof item.value === "number"
                        ? `₹${item.value.toLocaleString("en-IN")}`
                        : item.value}
                    </h3>
                  </div>
                </div>
              ))}
            </div>

            {/* EARNINGS HISTORY */}
            <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">
              <div className="px-6 py-4 border-b border-gray-100">
                <h2 className="text-lg font-semibold text-gray-900">
                  Earnings History
                </h2>
                <p className="text-sm text-gray-500">
                  Detailed breakdown of your mentoring sessions
                </p>
              </div>
              <div className="relative overflow-x-auto">
                <table className="min-w-[1200px] md:min-w-full">
                  <thead className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase">
                        Session
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase">
                        Date
                      </th>
                      <th className="px-6 py-3 text-right text-xs font-semibold text-gray-500 uppercase">
                        Amount
                      </th>
                      <th className="px-6 py-3 text-right text-xs font-semibold text-gray-500 uppercase">
                        Commission
                      </th>
                      <th className="px-6 py-3 text-right text-xs font-semibold text-gray-500 uppercase">
                        Payout
                      </th>
                      <th className="px-6 py-3 text-center text-xs font-semibold text-gray-500 uppercase">
                        Status
                      </th>
                    </tr>
                  </thead>

                  <tbody className="divide-y divide-gray-100">
                    {dashboard?.data?.earningsHistory?.length > 0 ? (
                      dashboard.data.earningsHistory.map((item, idx) => (
                        <tr
                          key={item._id}
                          className={`transition-colors ${idx % 2 === 0 ? "bg-white" : "bg-gray-50/50"
                            } hover:bg-indigo-50/40`}
                        >
                          <td className="px-6 py-4 text-sm font-medium text-gray-900">
                            {item.title}
                          </td>

                          <td className="px-6 py-4 text-sm text-gray-500">
                            {new Date(item.date).toLocaleDateString("en-IN")}
                          </td>

                          <td className="px-6 py-4 text-sm text-right text-gray-800">
                            ₹{item.amount.toLocaleString("en-IN")}
                          </td>

                          <td className="px-6 py-4 text-sm text-right text-red-600">
                            -₹{item.commission.toLocaleString("en-IN")}
                          </td>

                          <td className="px-6 py-4 text-sm text-right font-semibold text-emerald-600">
                            ₹{item.payout.toLocaleString("en-IN")}
                          </td>

                          <td className="px-6 py-4 text-center">
                            <button
                              onClick={() => navigate(`/meetingapplicants/${item.meeting_id}`)}
                              className="
              inline-flex items-center justify-center
              h-9 w-9 rounded-full
              bg-indigo-50 text-indigo-600
              hover:bg-indigo-100 hover:text-indigo-700
              transition-colors duration-200
              focus:outline-none focus:ring-2 focus:ring-indigo-400
            "
                              title="View details"
                            >
                              <Eye className="h-4 w-4" />
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={6} className="px-6 py-10 text-center">
                          <div className="flex flex-col items-center gap-2 text-gray-500">
                            <Eye className="h-6 w-6 text-gray-400" />
                            <p className="text-sm font-medium">No earnings found</p>
                            <p className="text-xs text-gray-400">
                              You haven’t completed any paid sessions yet
                            </p>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>

                </table>
              </div>
            </div>

          </main>}


        </div>
      </div>
      {showModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white w-full max-w-md rounded-2xl p-6 shadow-xl">

            {/* HEADER */}
            <h2 className="text-xl font-semibold mb-1 text-gray-800">
              Request Payout
            </h2>
            <p className="text-sm text-gray-500 mb-6">
              Available balance:
              <span className="font-semibold text-green-600 ml-1">
                ₹{availablePayout}
              </span>
            </p>

            {/* PAYOUT AMOUNT */}
            <div className="space-y-2 mb-4">
              <label className="text-sm font-semibold text-gray-700">
                Payout Amount
              </label>

              <input
                type="number"
                min="1"
                placeholder="Eg: ₹500"
                value={data.amount || ""}
                onChange={(e) => {
                  const value = Number(e.target.value);

                  // Reset error first
                  setError("");

                  // Only positive numbers
                  if (value <= 0) {
                    setError("Amount must be greater than 0");
                    setData({ ...data, amount: "" });
                    return;
                  }

                  // Cannot exceed available payout
                  if (value > availablePayout) {
                    setError("Amount exceeds available payout balance");
                    return;
                  }

                  setData({ ...data, amount: value });
                }}
                className="
            w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl
            focus:outline-none focus:ring-2 focus:ring-blue-500/20
            focus:border-blue-500 transition-all
          "
              />

              {/* ERROR MESSAGE */}
              {error && (
                <p className="text-sm text-red-500">{error}</p>
              )}
            </div>

            {/* ACTIONS */}
            <div className="flex items-center justify-end gap-3 pt-5 border-t border-gray-200">
              <button
                onClick={() => {
                  setShowModal(false);
                  setError("");
                  setData({ ...data, amount: null });
                }}
                className="
            px-4 py-2 rounded-lg text-sm
            bg-gray-100 text-gray-700
            hover:bg-gray-200 transition
          "
              >
                Cancel
              </button>

              <button
                disabled={!data.amount || error || loader}
                onClick={payoutRequest}
                className="
    px-5 py-2 rounded-lg text-sm font-semibold
    bg-blue-600 text-white
    hover:bg-blue-700 transition
    disabled:bg-gray-300
    disabled:cursor-not-allowed
    flex items-center justify-center gap-2
  "
              >
                {loader && (
                  <svg
                    className="w-4 h-4 animate-spin text-white"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                      fill="none"
                    />
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                    />
                  </svg>
                )}

                {loader ? "Processing..." : "Request Payout"}
              </button>

            </div>

          </div>
        </div>
      )}

    </>
  )
}

export default MentorDashboard

const SummaryCardSkeleton = () => {
  return (
    <div className="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm animate-pulse">
      <div className="h-4 w-24 bg-gray-200 rounded mb-3"></div>
      <div className="h-8 w-32 bg-gray-300 rounded"></div>
    </div>
  );
};

const TableRowSkeleton = () => {
  return (
    <tr className="animate-pulse">
      {[...Array(6)].map((_, i) => (
        <td key={i} className="px-6 py-4">
          <div className="h-4 w-full bg-gray-200 rounded"></div>
        </td>
      ))}
    </tr>
  );
};


const MentorEarningsSkeleton = () => {
  return (
    <main className="p-6 space-y-10 bg-gray-50 min-h-screen">

      {/* PAGE TITLE SKELETON */}
      <div className="space-y-2 animate-pulse">
        <div className="h-8 w-64 bg-gray-300 rounded"></div>
        <div className="h-4 w-96 bg-gray-200 rounded"></div>
      </div>

      {/* SUMMARY CARDS SKELETON */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {[...Array(4)].map((_, i) => (
          <SummaryCardSkeleton key={i} />
        ))}
      </div>

      {/* TABLE SKELETON */}
      <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">
        <div className="px-6 py-4 border-b border-gray-100 animate-pulse">
          <div className="h-5 w-40 bg-gray-300 rounded mb-2"></div>
          <div className="h-4 w-64 bg-gray-200 rounded"></div>
        </div>

        <div className="overflow-x-auto">
          <table className="min-w-[1200px] md:min-w-full">
            <tbody>
              {[...Array(5)].map((_, i) => (
                <TableRowSkeleton key={i} />
              ))}
            </tbody>
          </table>
        </div>
      </div>

    </main>
  );
};
